/**
 * @module Dashboard
 */

import { Component, Input } from '@angular/core';
import { DashboardLayoutClass } from '@class/dashboardLayout.class';
import { ItemColor } from '@functions/item.functions';

@Component({
  selector: 'app-dashboard-layout-gap',
  templateUrl: './dashboard-layout-gap.component.html',
  styleUrls: ['./dashboard-layout-gap.component.css']
})
export class DashboardLayoutGapComponent {

  @Input() dashboardLayout: DashboardLayoutClass;

  color = ItemColor('dashboards');
  
  constructor() {}

  receiveValue(gap: number) {
    this.dashboardLayout.change({ gap: gap });
  }

}
